function dm_back_to_top() {
    const btn = document.getElementById('backToTop');
    if (!btn) return;

    window.addEventListener('scroll', () => {
        const show = window.scrollY > 500;
        btn.style.opacity = show ? '1' : '0';
        btn.style.transform = show ? 'translateY(0)' : 'translateY(8px)';
        btn.style.pointerEvents = show ? 'auto' : 'none';
    });

    btn.addEventListener('click', () =>
        window.scrollTo({ top: 0, behavior: 'smooth' })
    );
}

export { dm_back_to_top };